// @api
import { APIGet/* , APIPost */ } from 'utilities/APIRequestHelper';

//@actions
import signaturePatternActions from 'actions/signaturePattern';

// @utils
import apiURLBuilder from 'core/apiURLBuilder';
const { getLanguage } = require('core/i18n').i18n;

// @constants
import {
    OK_WIZARD_ADD_STEP,
    OK_WIZARD_GET_INFO_FETCHING,
    OK_WIZARD_GET_INFO_SUCCESS,
    OK_WIZARD_GET_INFO_ERROR,
    OK_WIZARD_REMOVE_STEP,
    OK_WIZARD_RESET_DATA,
    OK_WIZARD_SET_ALL_ACCOUNTS_TO_INACTIVE,
    OK_WIZARD_SET_BUTTON_STATUS,
    OK_WIZARD_SET_CURRENT_STEP,
    OK_WIZARD_SET_TYPE_CHANGE,
    OK_WIZARD_SET_WIZARD_ERROR,
    OK_WIZARD_SET_WIZARD_SUCCESS,
    OK_WIZARD_GET_RESTRICTION_ERROR,
    OK_WIZARD_HIRE_CARD_LOADING,
    OK_WIZARD_SET_NGO_SELECTED,
    OK_WIZARD_SET_ASSOCIATE_ACCOUNT_SELECTED
} from 'constants/actionTypes';

export const addStep = (step, position) => ({
    type: OK_WIZARD_ADD_STEP,
    step,
    position
});

export const removeStep = position => ({
    type: OK_WIZARD_REMOVE_STEP,
    position
});

export const setCurrentStep = position => ({
    type: OK_WIZARD_SET_CURRENT_STEP,
    position
});

export const validateLoading = validateLoadingFlag => ({
    type: OK_WIZARD_HIRE_CARD_LOADING,
    validateLoadingFlag
});
 
export const resetData = () => ({
    type: OK_WIZARD_RESET_DATA
});

export const getWizardInfoFetching = () => ({
    type: OK_WIZARD_GET_INFO_FETCHING
});

export const getWizardInfoSuccess = response => ({
    type: OK_WIZARD_GET_INFO_SUCCESS,
    response
});

export const getWizardInfoError = error => ({
    type: OK_WIZARD_GET_INFO_ERROR,
    error
});

export const setWizardSuccess = error => ({
    type: OK_WIZARD_SET_WIZARD_SUCCESS,
    error
});

export const setWizardTypeChange = typeChange => ({
    type: OK_WIZARD_SET_TYPE_CHANGE,
    typeChange
});

export const setWizardError = error => ({
    type: OK_WIZARD_SET_WIZARD_ERROR,
    error
});

export const setWizardRestrictionError = (restrictionError, error) => ({
    type: OK_WIZARD_GET_RESTRICTION_ERROR,
    restrictionError,
    error,
});

export const getWizardInfoStepContents = contractId => (dispatch/* , getState */) => {
    const language = getLanguage().toUpperCase()
    const baseURL = apiURLBuilder.getURL('campaignEngine');
    return new Promise(() => {
        dispatch(getWizardInfoFetching());
        APIGet(dispatch,`${baseURL}/default/${language}/${contractId}/1`)
            .then(response => dispatch(getWizardInfoSuccess(response[0].body.value)))
            .catch(error => dispatch(getWizardInfoError(error.error)));
    });
}

export const validateGDPRAndOrOTP = cb => (dispatch, getState) => {
    signaturePatternActions.validateAndExecute(dispatch, getState, cb);
};

export const setWizardButtonStateByButton = (button, status) => dispatch => {
    dispatch({
        type: OK_WIZARD_SET_BUTTON_STATUS,
        button,
        status
    });
};

export const setAllAccountsToInactive = () =>({
    type: OK_WIZARD_SET_ALL_ACCOUNTS_TO_INACTIVE
});

export const setNgoSelected = (value) => ({
    type: OK_WIZARD_SET_NGO_SELECTED,
    payload: value
});

export const setAssociateAccountSelected = (value) => ({
    type: OK_WIZARD_SET_ASSOCIATE_ACCOUNT_SELECTED,
    payload: value
});